<template>
  <div>
    <roe-article-view ref="articleView"></roe-article-view>
    <div
      v-for="(articles, subcategory) in categoryArticles"
      class="pdf-right-panel-unit"
    >
      <div class="pdf-right-panel-unit-header">
        {{ subcategory }}
      </div>
      <div v-for="article in articles" class="pdf-right-panel-unit-content">
        <h4>{{ article.title }}</h4>
        <div class="light-label">{{ article.bullet_point }}</div>
        <div class="pdf-right-panel-unit-content-actions">
          <div class="btn-wrap">
            <button class="btn-primary" @click.stop="add(article)">
              Add to page
            </button>
          </div>
          <div class="btn-wrap">
            <button
              class="btn-secondary"
              @click.stop="$refs.articleView.open(article)"
            >
              More info
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { REPORT_ARTICLE_ADD } from "@/store/actions.type";
import RoeArticleView from "./ArticleView";
export default {
  name: "RoeSelectArticles",
  components: { RoeArticleView },
  props: {
    categoryArticles: {
      type: Object,
      required: true
    },
    selectedArticles: {
      type: Array,
      required: true
    }
  },
  methods: {
    add(article) {
      if (this.selectedArticles.length === 3) {
        this.flashMessage.error({ title: "Error", message: "You can not add more than 3!" });
      } else
        this.$store.dispatch(REPORT_ARTICLE_ADD, {
          reportId: this.$route.params.id,
          article: article
        });
    }
  }
};
</script>
